import React from 'react'
import { MultiLevelSidebar } from '../Components/Layout/Sidebar'
import HomeForm from '../Components/HomeContent/HomeForm'

const Home = () => {  
  return (
    <div className='grid bg-gray-200 h-[100vh] overflow-y-scroll grid-cols-5 grid-flow-col' >
      <MultiLevelSidebar />
   
    </div>
  )
}

export default Home